import api2 from './api-v2';

const get = async (filter) => {
    const client = await api2.getClient();
    const response = await client.get('cluster-groups', { params: filter });
    return api2.handleSuccess(response);
};

const getById = async ({ id }) => {
    const client = await api2.getClient();
    const app = await client.get(`cluster-groups/${id}`);
    return api2.handleSuccess(app);
};

const create = async ({ payload }) => {
    const client = await api2.getClient();
    const response = await client.post('cluster-groups', payload);
    return api2.handleSuccess(response);
};

const update = async (id, { payload }) => {
    const client = await api2.getClient();
    const response = await client.put(`cluster-groups/${id}`, payload);
    return api2.handleSuccess(response);
};

const remove = async (id) => {
    const client = await api2.getClient();
    const response = await client.delete(`cluster-groups/${id}`);
    return api2.handleSuccess(response);
};

const getClusters = async ({ id }) => {
    const client = await api2.getClient();
    const response = await client.get(`cluster-groups/${id}/clusters`);
    return api2.handleSuccess(response);
};

export default {
    get,
    getById,
    create,
    update,
    remove,
    getClusters
};
